import InfoModalInteriorCombination from './InfoModalInteriorCombination'
import infoModalContainer from './infoModalInteriorCombinationContainer'

export default infoModalContainer(InfoModalInteriorCombination)
